// Pick a localized field for the active language, with a hard English fallback.
// Prefers the flexible `translations` JSON map ({ en, nl, th, ... } — any language); falls back to
// the legacy lang_<code> columns so older rows / mid-transition data still render.
export default function localized(obj, lang) {
  if (!obj) return '';
  let t = obj.translations;
  if (typeof t === 'string') { try { t = JSON.parse(t); } catch { t = null; } }
  if (t && typeof t === 'object') {
    if (t[lang]) return t[lang];
    if (t.en) return t.en;
  }
  return obj['lang_' + lang] || obj.lang_en || '';
}

// Localized DESCRIPTION: prefers desc_translations[lang], then English, then the legacy single
// `description` column — so a dish shows in whatever language(s) the owner actually typed.
export function localizedDesc(obj, lang) {
  if (!obj) return '';
  let t = obj.desc_translations;
  if (typeof t === 'string') { try { t = JSON.parse(t); } catch { t = null; } }
  if (t && typeof t === 'object') {
    if (t[lang]) return t[lang];
    if (t.en) return t.en;
  }
  return obj.description || '';
}
